import { Coordinate } from 'ol/coordinate'

const longLatToCoord = (longitude: string | number, latitude: string | number): Coordinate => {
  const longitudeNumber = typeof longitude === 'string' ? parseFloat(longitude) : longitude
  const latitudeNumber = typeof latitude === 'string' ? parseFloat(latitude) : latitude
  return [longitudeNumber, latitudeNumber]
}

export const MapUtils = { longLatToCoord }